import { SignedImg } from "@/components/shared/SignedImg";

// Sdílené drobnosti pro celý modul Pasport (zadání 73/74).
export const fmtQty = (q) => String(q ?? "").replace(".", ",");
export const fmtDate = (iso) => {
  const [y, m, d] = (iso || "").split("-");
  return d ? `${+d}. ${+m}. ${y}` : iso || "";
};
export const domain = (u) => {
  try { return new URL(u).hostname.replace(/^www\./, ""); } catch { return u; }
};
// 311: položka objednaná přes Objednávky — stav, dodavatel, termín a číslo z objednávky.
const ST = { ordered: "Objednáno", confirmed: "Potvrzeno", shipped: "Na cestě", ready: "K vyzvednutí", received: "Převzato" };
export function orderState(o) {
  const due = o.due_date ? `${+o.due_date.slice(8, 10)}. ${+o.due_date.slice(5, 7)}.` : null;
  return {
    title: ST[o.status] || "Objednáno",
    sub: [o.supplier, o.status !== "received" && (due ? `termín ${due}` : "bez termínu"), o.no && `č. ${o.no}`].filter(Boolean).join(" · "),
  };
}
export const kb = (n) => `${Math.max(1, Math.round((n || 0) / 1024))} kB`;

export const STATE_OPTS = [
  ["nodekor", "Bez dekoru / odkazu"],
  ["todo", "K objednání"],
  ["ordered", "Objednáno"],
  ["notordered", "Neobjednáno"],
];

// Zda položka projde filtry (jeden zdroj pravdy pro tabulku i počty).
export function itemMatches(it, decorById, { q, fstate, fcats, fsups }) {
  const d = decorById[it.dekor_id];
  const hasDecor = !!(it.dekor_id || it.dekor_text);
  if (q) {
    const s = q.toLowerCase();
    const inLabel = (it.label || "").toLowerCase().includes(s);
    const inDecor = (d?.name || it.dekor_text || "").toLowerCase().includes(s);
    if (!inLabel && !inDecor) return false;
  }
  if (fstate === "nodekor" && hasDecor) return false;
  if (fstate === "todo" && (!hasDecor || it.order)) return false;
  if (fstate === "ordered" && !it.order) return false;
  if (fstate === "notordered" && it.order) return false;
  if (fcats.length && !fcats.includes(it.category || "Bez kategorie")) return false;
  if (fsups.length && !fsups.includes(d?.supplier || "—")) return false;
  return true;
}

// Vzorek dekoru (fotka z našeho storage, jinak neutrální plocha).
export function Swatch({ decor, size = 24 }) {
  const src = decor?.thumb_url || decor?.image_url;
  return (
    <span style={{ width: size, height: size }}
      className="rounded-[7px] border border-border overflow-hidden shrink-0 bg-secondary inline-block">
      {src && <SignedImg url={src} alt="" className="w-full h-full object-cover" />}
    </span>
  );
}
